import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAdminAuth, useNoIndex } from "@/admin/AdminAuth";
import { apiError } from "@/admin/adminApi";
import { btnPrimary, fieldInput, fieldLabel } from "@/admin/ui";
import { DEEP_PETROL } from "@/admin/AdminLayout";

export default function AdminLogin() {
  useNoIndex();
  const { user, login } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate(location.state?.from || "/admin", { replace: true });
    } catch (err) {
      setError(apiError(err, "A bejelentkezés nem sikerült."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen grid md:grid-cols-2 bg-warm">
      <section className="hidden md:flex flex-col justify-between p-14" style={{ background: DEEP_PETROL }}>
        <p className="font-serif-display text-[26px] text-[#F4EEE2]">
          Szász-Tóth <em className="text-[#D9BE85]" style={{ fontStyle: "italic" }}>Enikő</em>
        </p>
        <div>
          <p className="font-body text-[11px] tracking-[0.34em] uppercase text-[#D9BE85] mb-5">Forrás-Kód® programok</p>
          <p className="font-serif-display italic text-[34px] leading-[1.25] text-[#F4EEE2] max-w-md">
            Programok, időpontok és jelentkezők — egy helyen.
          </p>
        </div>
        <p className="font-body text-[12px] text-[#F4EEE2]/50">Védett adminisztrációs felület</p>
      </section>
      <section className="flex items-center justify-center px-6 py-16">
        <form onSubmit={handleSubmit} data-testid="admin-login-form" className="w-full max-w-sm">
          <Lock className="w-5 h-5 text-gold mb-6" strokeWidth={1.5} />
          <h1 className="font-serif-display text-[36px] leading-tight text-graphite mb-2">Bejelentkezés</h1>
          <p className="font-body text-[14px] text-graphite-soft mb-9">Kizárólag adminisztrátori hozzáféréssel.</p>
          <label htmlFor="admin-email" className={fieldLabel}>E-mail-cím</label>
          <input id="admin-email" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" className={`${fieldInput} mb-5`} />
          <label htmlFor="admin-password" className={fieldLabel}>Jelszó</label>
          <input id="admin-password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" className={fieldInput} />
          {error && <p data-testid="admin-login-error" className="mt-4 font-body text-[13.5px] text-[#9A3B2E]">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className={`${btnPrimary} w-full mt-8`}>
            {loading ? "Belépés…" : "Belépés"}
          </button>
        </form>
      </section>
    </main>
  );
}
